// extracted by mini-css-extract-plugin
module.exports = {"root":"HeaderRow_root__1v4_N","pageTitle":"HeaderRow_pageTitle__3qcN1","pageSubTitle":"HeaderRow_pageSubTitle__KUDyO"};